import React from 'react'
import { makeStyles } from '@material-ui/styles'
import PaperWithPadding from 'components/templates/PaperWithPadding'
import VerticalWidget from '../organisms/VerticalWidget'
import useInitialProps from '../../hooks/useStaticContext'

const useStyles = makeStyles({
  root: {
    width: 'fit-content',
  },
})

const VerticalWidgetPage = ({ staticContext }) => {
  const { handicaps = {}, picture = null, cardUrl = null } = useInitialProps(
    staticContext
  )

  const classes = useStyles()

  return (
    handicaps && (
      <PaperWithPadding padding={0.5} className={classes.root}>
        <VerticalWidget
          handicaps={handicaps}
          cardUrl={cardUrl}
          picture={picture}
        />
      </PaperWithPadding>
    )
  )
}
export default VerticalWidgetPage
